import { ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { ErrorSplash } from 'assets/js/pages/ErrorSplash';

interface ErrorBoundaryProps {
    children: ReactNode;
}

const SentryErrorBoundary = ({ children }: ErrorBoundaryProps) => (
    <Sentry.ErrorBoundary fallback={ErrorSplash}>{children}</Sentry.ErrorBoundary>
);

export { SentryErrorBoundary };
